/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ClassroomdisciplineIdMaterialsMaterialid202,
  DeleteApiV1ClassroomdisciplineIdMaterialsMaterialid401,
  DeleteApiV1ClassroomdisciplineIdMaterialsMaterialid404,
  DeleteApiV1ClassroomdisciplineIdMaterialsMaterialidMutationResponse,
  DeleteApiV1ClassroomdisciplineIdMaterialsMaterialidPathParams,
} from "../../types/classPlanningMaterialController/DeleteApiV1ClassroomdisciplineIdMaterialsMaterialid.ts";

export const deleteApiV1ClassroomdisciplineIdMaterialsMaterialidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    materialId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdMaterialsMaterialidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ClassroomdisciplineIdMaterialsMaterialid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdMaterialsMaterialid202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ClassroomdisciplineIdMaterialsMaterialid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdMaterialsMaterialid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ClassroomdisciplineIdMaterialsMaterialid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdMaterialsMaterialid404>;

export const deleteApiV1ClassroomdisciplineIdMaterialsMaterialidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ClassroomdisciplineIdMaterialsMaterialid202Schema,
  ) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdMaterialsMaterialidMutationResponse>;
